export const UserType: Record<string, Users.Type> = {
  Customer: 'customer',
  Admin: 'admin',
};
